var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1677 4.40039H5.83435C4.88065 4.4039 3.96701 4.78433 3.29264 5.4587C2.61827 6.13307 2.23789 7.04669 2.23438 8.00039V24.0004C2.23789 24.9541 2.61827 25.8677 3.29264 26.5421C3.96701 27.2165 4.88065 27.5969 5.83435 27.6004H27.1677C28.1225 27.6004 29.0382 27.2211 29.7133 26.546C30.3884 25.8708 30.7677 24.9552 30.7677 24.0004V8.00039C30.7677 7.04561 30.3884 6.12994 29.7133 5.45481C29.0382 4.77968 28.1225 4.40039 27.1677 4.40039ZM4.19438 7.45374C4.30893 7.10904 4.52885 6.80904 4.82312 6.59611C5.11739 6.38318 5.47112 6.26809 5.83435 6.26707H27.1677C27.5332 6.26529 27.8899 6.37908 28.1868 6.5922C28.4838 6.80533 28.7058 7.10688 28.821 7.45374V7.54706L28.741 7.61373L16.4744 16.1871H16.4077L4.14103 7.6004L4.19438 7.45374ZM28.901 24.0004C28.901 24.4601 28.7184 24.901 28.3934 25.2261C28.0683 25.5511 27.6274 25.7337 27.1677 25.7337H5.83435C5.37572 25.7303 4.9369 25.5465 4.61259 25.2222C4.28828 24.8979 4.10452 24.459 4.10103 24.0004V9.78707L15.9677 18.0937C16.1262 18.2038 16.3147 18.2628 16.5077 18.2628C16.7007 18.2628 16.8891 18.2038 17.0477 18.0937L28.901 9.78707V24.0004Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpMail);
export default __webpack_public_path__ + "static/media/help-mail.216f276a879c2f0e71fe29bc9a1592cf.svg";
export { ForwardRef as ReactComponent };